'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var activity = function activity() {
  return import('@/page/activityCenter/activity');
};
var activityCenter = function activityCenter() {
  return import('@/page/activityCenter');
};
var activityCenterDetail = function activityCenterDetail() {
  return import('@/page/activityCenter/detail');
};
var activityCenterReviewActive = function activityCenterReviewActive() {
  return import('@/page/activityCenter/detail-info/review-active');
};
exports.default = [{
  path: '/activity',
  name: 'activity',
  component: activity,
  children: [{
    path: '/activityCenter',
    name: 'activityCenter',
    component: activityCenter
  }, {
    path: 'activityCenterDetail',
    name: 'activityCenterDetail',
    component: activityCenterDetail
  }, {
    path: 'activityCenterReviewActive',
    name: 'activityCenterReviewActive',
    component: activityCenterReviewActive
  }]
}];